module.exports = __webpack_public_path__ + "static/media/Logo.54655db0.svg";